import { Meta, StoryObj } from "@storybook/nextjs-vite";

import { ProductCard } from "./ProductCard";

const meta: Meta<typeof ProductCard> = {
  title: "Product card",
  component: ProductCard,
  args: {
    type: "Product",
    title: "SolarWinds Observability SaaS",
    subhead: "Full-stack observability. No infrastructure required.",
    description:
      "Metrics, logs, traces, APM, and digital experience monitoring in a single SaaS platform built for modern cloud environments.",
    link: {
      title: "Start Trial",
      url: "#",
      dld: "start-trial",
      dlt: "Product Card",
      underTitle: "30-day trial",
    },
    secondLink: {
      title: "Quick View",
      dld: "quick-view",
      dlt: "Product Card",
    },
    thirdLink: {
      title: "SolarWinds Observability SaaS",
      url: "#",
      dld: "solarwinds-observability-saas",
      dlt: "Product Card Title",
    },
    modal: (
      <div className="flex flex-col gap-6 border p-6">
        <div className="flex min-h-10 items-center gap-8">
          <h2 className="text-headline text-subhead-s min-w-0 font-bold">
            SolarWinds Observability SaaS
          </h2>
          <div aria-hidden className="ml-auto size-6 shrink-0" />
        </div>
        <p className="text-body-primary text-body-s">
          Product quick-view content
        </p>
      </div>
    ),
  },
  decorators: [
    (Story) => (
      <div className="mx-auto w-full max-w-lg">
        <Story />
      </div>
    ),
  ],
};

export default meta;

export const Default: StoryObj<typeof ProductCard> = {};
